import { Component, OnInit } from '@angular/core';
import { UserPermissionsService } from 'src/app/shared/services/user-permissions.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { searchOrganization } from 'src/app/shared/models/oarganization';
import { LoaderModule } from "../../../shared/components/loader/loader.module";
import { OrganizationsService } from 'src/app/shared/services/organizations.service';

@Component({
  selector: 'app-user-permissions',
  templateUrl: './user-permissions.component.html',
  styleUrls: ['./user-permissions.component.scss'],
})
export class UserPermissionsComponent implements OnInit {
  permissions: any=[];
  userPermissions: string[];
  orgList: searchOrganization[] = [];
  searchControl = new FormControl("");
  isLoading: boolean;
  organizationId: any;
  selectedOrg: string;


  constructor(
    private userPermissionsService : UserPermissionsService,
    private orgService : OrganizationsService,
    private toasterService: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.userPermissions = sessionStorage.getItem("userPermissions").split(",");
    this.searchPermission();
    this.searchOrganizations();
    this.selectedOrg = "";
    sessionStorage.removeItem('permissionType');
  }

  applyFilter(event: Event) {
    const filterValue = ((event.target as HTMLInputElement).value).toLowerCase();
    this.searchPermission(filterValue);
  }
  async searchPermission(filterValue?: string){
    this.isLoading = true;
    try{  
      const payload = {
        searchString : filterValue ? filterValue : this.searchControl.value,
        organizationId: this.organizationId
      }
      const result: any = await this.userPermissionsService.search(payload).toPromise();
      if(result.success){ 
        this.permissions = result.permissions;
        this.isLoading = false;
      }
    }
    catch(err: any){
      console.log(err);
      this.isLoading = false;
    }
  }

  
  async searchOrganizations() {
    try {
      this.isLoading = true;
      const payload: searchOrganization = {
        isActive: true
      }
      const result: any = await this.orgService.search(payload).toPromise();
      this.isLoading = false;
      if (result && result.organizations.length > 0) {
        if(result && result.organizations.length === 1 ){
          this.selectedOrg = result.organizations[0].orgId;
          this.organizationId = result.organizations[0].orgId;
          this.searchPermission();
        }
        this.orgList = result.organizations;
      }
    } catch (e: any) {
      console.log(e);
      if (e.status == 403) {
        this.toasterService.error(e.error.message)
      }
    }
  }

  onChange(event: any) {
    if (event.target.value != "") {
      this.organizationId = event.target.value;
    } else {
      this.organizationId = null;
    }
    this.searchPermission();
  }

  addUserPermissions(){
    this.router.navigateByUrl('/admin/add-user-permissions')
  }

  updateUserPermissions(item: any){
    sessionStorage.setItem('permissionType', item.permission_type);
    this.router.navigateByUrl(`admin/edit-user-permissions/${item.user_id}/${item.organization_id}`)
  }

}
